import React from 'react';

export const Delete = ({
  className,
  width,
  height,
  color,
}: {
  className?: string;
  width?: string;
  height?: string;
  color?: string;
}) => (
  <svg
    width={width ?? '29'}
    height={height ?? '29'}
    viewBox={height ? `0 0 ${width} ${height}` : '0 0 29 29'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3359 6.60107V5.43441H17.0026V6.60107H12.3359ZM10.0026 6.60107V4.26774C10.0026 3.62341 10.5249 3.10107 11.1693 3.10107L18.1693 3.10107C18.8136 3.10107 19.3359 3.62341 19.3359 4.26774V6.60107H20.3522L22.8359 6.60107C23.4803 6.60107 24.0026 7.12341 24.0026 7.76774C24.0026 8.41207 23.4803 8.93441 22.8359 8.93441H22.6857C22.6856 8.98262 22.6841 9.03115 22.681 9.07996L21.806 23.08C21.7292 24.3097 20.7094 25.2677 19.4772 25.2677L9.86135 25.2677C8.6292 25.2677 7.60942 24.3097 7.53256 23.08L6.65756 9.07996C6.65451 9.03115 6.65298 8.98262 6.65293 8.93441H6.5026C5.85827 8.93441 5.33594 8.41207 5.33594 7.76774C5.33594 7.12341 5.85827 6.60107 6.5026 6.60107H8.98635L10.0026 6.60107ZM18.1693 8.93441L11.1693 8.93441L8.98635 8.93441L9.86135 22.9344L19.4772 22.9344L20.3522 8.93441L18.1693 8.93441Z"
      fill={color ?? '#6B778C'}
    />
  </svg>
);
